module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAPCAYAAAAYjcSfAAAA6ElEQVQ4jcWUMQ6CQBBFP8Y7SGW5ewto6AjcgkI7Ck7BJpQkcgs4gceYtbOSAxhjpUPEEGPjoOBPpthJdt/+mdl1zpfrDTNrMTdwJNTC+Gus3D78AiQ8YSkHBshViXYfClGDHElPyQTwKEVbjQd2EpTXomks4vg7oBB6AJGCRgHPHXqaNFNCyfLAWOQGqE5HtF1wmeskgBFOknB6FbJdym57RSkybVFz2SeEvl9CKfmuz6E6RMyu6MWUheW11jKywKlCFCnu4QZ1nyGzRU4h50VM2Tt9gPitmqfdkIeqRCxjyqG/0F8+/Dt3PU/6U6OhLwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/nrtb1-15.png
// module id = 694
// module chunks = 0